/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_SyncInputs */

const en_offline_sync = /** @type {(inputs: Offline_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline Sync`)
};

const fr_offline_sync = /** @type {(inputs: Offline_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation hors ligne`)
};

const de_offline_sync = /** @type {(inputs: Offline_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline-Synchronisierung`)
};

const it_offline_sync = /** @type {(inputs: Offline_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizzazione offline`)
};

const ru_offline_sync = /** @type {(inputs: Offline_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оффлайн-синхронизация`)
};

const es_offline_sync = /** @type {(inputs: Offline_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización sin conexión`)
};

const zh_cn2_offline_sync = /** @type {(inputs: Offline_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线同步`)
};

const ja_offline_sync = /** @type {(inputs: Offline_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフライン同期`)
};

const hi_offline_sync = /** @type {(inputs: Offline_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफलाइन सिंक`)
};

const pt_pt2_offline_sync = /** @type {(inputs: Offline_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização offline`)
};

/**
* | output |
* | --- |
* | "Offline Sync" |
*
* @param {Offline_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync = /** @type {((inputs?: Offline_SyncInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_SyncInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync(inputs)
	if (locale === "de") return de_offline_sync(inputs)
	if (locale === "it") return it_offline_sync(inputs)
	if (locale === "ru") return ru_offline_sync(inputs)
	if (locale === "es") return es_offline_sync(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync(inputs)
	if (locale === "ja") return ja_offline_sync(inputs)
	if (locale === "hi") return hi_offline_sync(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync(inputs)
	return en_offline_sync(inputs)
});